import { RestartAlt } from '@mui/icons-material';
import { Button, Tooltip, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setRenderDashboard } from '../../redux/reducers/DashboardSlice';
import { profitNLossApi } from '../../redux/apis/profitNLoss.api';
import { balanceSheetApi } from '../../redux/apis/balanceSheet.api';
import { trialBalanceApi } from '../../redux/apis/trailBalance.api';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { listGroupMasterApi } from '../../redux/apis/accountGroupMaster.api';
import { listAccountOpeningBalanceApi } from '../../redux/apis/accountOpeningBalance.api';

function DbReloadBtn({ tab }) {
  const dispatch = useDispatch();
  const [isReloading, setIsReloading] = useState(false);
  
  const handleBtn = async () => {
    try {
      setIsReloading(true);
      
      switch (tab) {
        case 'item':
          // Invalidate item-related data
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemCategoryMaster']));
          dispatch(dashboardApi.util.invalidateTags(['listStockSummary']));
          break;
        default:
          // Invalidate all dashboard-related data
          dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock']));
          dispatch(listGroupMasterApi.util.invalidateTags(['listGroupMaster']));
          dispatch(trialBalanceApi.util.invalidateTags(['TrialBalanceData']));
          dispatch(listAccountOpeningBalanceApi.util.invalidateTags(['listAccountOpeningBalance', 'allaccounts']));
          dispatch(profitNLossApi.util.invalidateTags(['profitNLoss']));
          dispatch(balanceSheetApi.util.invalidateTags(['balanceSheet']));
          break;
      }
      
      // Add a small delay to show loading state and ensure user sees the feedback
      setTimeout(() => {
        setIsReloading(false);
      }, 1000);
      
    } catch (error) {
      console.error('An error occurred while invalidating tags:', error);
      setIsReloading(false);
    }
  };

  return (
    <>
      <Tooltip title={isReloading ? "Reloading..." : "Reload"} arrow>
        <Button
          disableRipple
          disableElevation
          variant="outlined"
          disabled={isReloading}
          sx={{
            color: isReloading ? 'text.secondary' : 'primary.main',
            backgroundColor: 'bodyGray.main',
            fontSize: '12px',
            border: '1px solid',
            borderColor: 'bodyGray.main',
            height: '30px',
            boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
            // marginLeft: { xs: "0px", sm: "20px" },
            // marginBottom: { xs: "20px", sm: "0px" },
            // height: "30px",
            minWidth: { xs: '50px', sm: '64px' },
            opacity: isReloading ? 0.7 : 1,
            '&:hover': {
              backgroundColor: isReloading ? 'bodyGray.main' : 'primary.light',
            },
          }}
          onClick={handleBtn}
        >
          {isReloading ? (
            <CircularProgress size={16} sx={{ color: 'primary.main' }} />
          ) : (
            <RestartAlt />
          )}
        </Button>
      </Tooltip>
    </>
  );
}

export default DbReloadBtn;
